<template>
	<div class="holder" :class="{ labeled: label }">
		<div class="label" v-if="label">{{ label }}</div>
		<div class="switch" :class="{ active: innerValue, border: border }" @click="toggle">
			<span />
		</div>
	</div>
</template>

<script>
export default {
	name: 'uiSwitch',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		border: {
			type: Boolean,
			default: false,
		},
		label: String,
	},
	data() {
		return {
			innerValue: this.value,
		}
	},
	methods: {
		toggle() {
			this.$emit('input', !this.innerValue)
		},
	},
	watch: {
		value(newVal) {
			this.innerValue = newVal
		},
	},
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

.holder {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;

	&.labeled {
		margin-bottom: 10px;
	}
}

.switch {
	position: relative;
	width: 60px;
	height: 30px;
	padding: 3px;
	border-radius: 18px;
	background-color: @grey;
	transition: background-color 0.3s;
	box-sizing: border-box;
	cursor: pointer;

	&.border {
		box-shadow: 0 0 20px fade(#000, 10%);
	}

	&.active {
		background-color: @accent;

		span {
			transform: translateX(30px);
		}
	}

	span {
		display: block;
		width: 24px;
		height: 24px;
		background-color: #fff;
		border-radius: 50%;
		transition: transform 0.3s;
	}
}
</style>
